<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.fornecedores.labels.titulo")',
        :voltarPara='{ route: "ConfiguracaoRastreabilidade" }',
        :btnTexto='$t("mensagens.fornecedores.labels.novoFornecedor")',
        exibeBotao,
        icon='el-icon-plus',
        @btnHeaderClicado='goToCadastroFornecedor'
    )
    .bloco-fornecedores
        .bloco-input
            .bloco-input__icon
                i.el-icon-search
            .bloco-input__input
                input.input-search(
                    v-model='filtro',
                    type='text',
                    :placeholder='$t("mensagens.fornecedores.labels.placeholder")',
                    autocomplete='off',
                    @keyup.enter='buscarFornecedores(1)'
                )
        .bloco-listagem-fornecedores
            h3 {{ $t('mensagens.fornecedores.labels.listagem') }}
            el-table(:key="listagemTableKey('fornecedores', fornecedores, paginacao.pagina + 1)", :data='fornecedores')
                el-table-column(type='expand')
                    template(slot-scope='scope')
                        .bloco-lista-cpf-cnpj(
                            v-if='scope.row.cpfsCnpjs && scope.row.cpfsCnpjs.length > 1'
                        )
                            label {{ $t('mensagens.fornecedores.labels.cpfCnpj') }}
                            ul
                                li(
                                    v-for='cpfCnpj in scope.row.cpfsCnpjs',
                                    :key='cpfCnpj'
                                ) {{ formatCpfCnpj(cpfCnpj) }}
                        .bloco-lista-cpf-cnpj(v-else)
                            span {{ $t('mensagens.fornecedores.labels.semCpfCnpjAdicional') }}
                el-table-column(
                    prop='idSap',
                    :label='$t("mensagens.fornecedores.labels.idSap")'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.idSap || '-' }}
                el-table-column(
                    prop='nome',
                    :label='$t("mensagens.fornecedores.labels.nome")'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.nome || '-' }}
                el-table-column(
                    prop='cpfsCnpjs[0]',
                    :label='$t("mensagens.fornecedores.labels.cpfCnpj")'
                )
                    template(slot-scope='scope')
                        div(
                            v-if='scope.row.cpfsCnpjs && scope.row.cpfsCnpjs.length > 0'
                        )
                            p {{ formatCpfCnpj(scope.row.cpfsCnpjs[0]) }}
                                el-tag.ml-2(
                                    v-if='scope.row.cpfsCnpjs.length > 1',
                                    size='mini'
                                )
                                    | + {{ scope.row.cpfsCnpjs.length - 1 }}
                        div(v-else)
                            p -
                el-table-column(
                    :label='$t("mensagens.fornecedores.labels.acao")',
                    :min-width='15',
                    align='center'
                )
                    .template(slot-scope='scope')
                        el-dropdown.action-button(trigger='click')
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical
                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-view',
                                    @click.native='irParaVisualizarFornecedor(scope.row)'
                                ) {{ $t('mensagens.fornecedores.labels.visualizar') }}
                                el-dropdown-item(
                                    icon='el-icon-edit',
                                    @click.native='goToEditarFornecedor(scope.row)'
                                ) {{ $t('mensagens.fornecedores.labels.editar') }}
                                el-dropdown-item(
                                    icon='el-icon-delete',
                                    @click.native='removerFornecedor(scope.row)'
                                ) {{ $t('mensagens.fornecedores.labels.remover') }}
                template(slot='empty')
                el-empty(description='Não há fornacedores')
            .bloco-paginacao
                span {{ formatarFornecedores(paginacao.total) }}
                el-pagination(
                    background,
                    :page-size='paginacao.itensPorPagina',
                    :current-page.sync='paginacao.pagina + 1',
                    layout='prev, pager, next',
                    :total='paginacao.total',
                    @current-change='mudarPagina'
                )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import formatters from '@/utils/formatters';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';

export default {
    name: 'ConfiguracaoFornecedores',
    components: {
        BaseHeader
    },
    data() {
        return {
            filtro: '',
            pageable: {
                page: 0,
                size: 10,
                sort: 'nome',
                order: 'asc'
            },
            fornecedores: [],
            paginacao: {}
        };
    },
    mounted() {
        this.buscarFornecedores(1);
    },
    methods: {
        async buscarFornecedores(page) {
            this.pageable.page = page - 1;
            const { data } =
                await ContratoOriginacaoService.buscarFornecedoresPorFiltro(
                    { nome: this.filtro },
                    this.pageable
                );
            this.fornecedores = data.fornecedores;
            this.paginacao = data.paginacao;
        },
        formatCpfCnpj(value) {
            if (!value || value.trim() === '') return '-';
            return formatters.numeralStringFormatTocpfCnpj(value);
        },
        mudarPagina(page) {
            this.buscarFornecedores(page);
        },
        async removerFornecedor(row) {
            const result = await this.$messageBox.confirm(
                this.$t('mensagens.sistema.removerFornecedor'),
                this.$t('mensagens.comuns.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            );
            if (result === 'confirm') {
                try {
                    const payload = this.montarPayload(row);
                    const { data } =
                        await ContratoOriginacaoService.removerFornecedor(
                            payload
                        );
                    this.$notify.success(data);
                    await this.buscarFornecedores(1);
                } catch (error) {}
            }
        },
        goToCadastroFornecedor() {
            this.$router.push({ name: 'CadastroFornecedor' });
        },
        irParaVisualizarFornecedor(row) {
            this.$router.push({
                name: 'DetalhesFornecedor',
                params: { resume: row }
            });
        },
        goToEditarFornecedor(row) {
            this.$router.push({
                name: 'EditarFornecedor',
                params: { row: row }
            });
        },
        montarPayload(row) {
            return {
                nome: row.nome
            };
        },
        formatarFornecedores(total) {
            return total > 1
                ? `${total} ${this.$t(
                      'mensagens.fornecedores.labels.fornecedores'
                  )}`
                : `${total} ${this.$t(
                      'mensagens.fornecedores.labels.fornecedor'
                  )}`;
        }
    }
};
</script>

<style lang="scss">
.bloco-fornecedores {
    margin: 20px;
}

.bloco-input {
    display: flex;
    background-color: $white;
    padding: 7px 10px;
    border-radius: $default-border-radius;
    gap: 5px;
    align-items: center;
    @include default-box-shadow();
}

.bloco-input__icon i {
    color: $primary;
}

.bloco-input__input {
    flex: 1;

    input {
        border: 0 !important;
        outline: 0;
        width: 100%;
    }
}

.bloco-listagem-fornecedores {
    margin-top: 20px;

    h3 {
        margin-bottom: 5px;
    }

    .el-table {
        border-radius: 4px 4px 0 0;
        @include default-box-shadow();
    }
}

.bloco-lista-cpf-cnpj {
    margin-left: 20px;
    display: flex;
    flex-direction: column;

    label {
        font-weight: bold;
    }

    ul {
        margin: 5px 0 0 0;
        padding: 0;
        list-style: none;

        li {
            padding: 7px;
            border-top: 1px solid #f0f2f7;
            font-size: 12px;
        }
    }
}

.bloco-paginacao {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background-color: $white;
    border-radius: 0 0 4px 4px;
    padding: 15px;

    span {
        color: $primary;
        font-weight: bold;
    }
}
</style>
